<template>
  <div class="pagination">
    <div v-for="item in total_page" :key="item">
      <div v-if="item === +$route.query.page || (!$route.query.page && (item === 1))" @click="handleClickPagination(item)" class="item active">
        <p>{{ item }}</p>
      </div>
      <div v-else-if="item !== +$route.query.page" @click="handleClickPagination(item)" class="item">
        <p>{{ item }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    total_page: {
      type: Number,
      default: 0
    }
  },
  methods: {
    handleClickPagination (page) {
      if (!+this.$route.query.page && +page !== 1) {
        this.toPage(page)
      } if (+this.$route.query.page && +this.$route.query.page !== +page) {
        this.toPage(page)
      }
    },
    toPage (page) {
      const query = this.$route.query
      query.page = `${page}`
      this.$router.push({ path: this.$route.path, query: query })
        .catch(() => {
          this.$router.replace({ query: { page: null } })
          this.$router.replace({ query: query })
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.pagination {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 20px;
  .item {
    cursor: pointer;
    margin-left: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    height: 30px;
    width: 30px;
    box-shadow: rgba(0, 0, 0, 0.15) 2.4px 2.4px 3.2px;
    background-color: rgb(0, 123, 255);
    transition: .1s;
    &:hover {
      background-color: rgb(10, 70, 135);
    }
    p {
      font-weight: 500;
      color: #ffffff;
    }
    &.active {
      background-color: white;
      border: 2px solid var(--color-blue-background);
      cursor: default;
      p {
        color: rgb(10, 70, 135);
      }
    }
  }
}
</style>
